<top-navigation class="d-print-none"></top-navigation>

<main>
    <main-banner [spanishName]="spanishDiseaseName" [title]="spanishDiseaseName" [englishURL]="englishURL"></main-banner>

    <div class="container-xxxl pt-5 spanish-page">
        <div class="spanish-content" [innerHTML]="spanishContent" (click)="onClick($event)"></div>
    </div>
</main>

<app-footer></app-footer>
